import './Label.scss';
import { TextBase } from '@components/Component/TextBase/TextBase.js';
/**
 * `Label` component accompanies an input
 */
export class Label extends TextBase {
    constructor(id, rootElement, dependencies = {}) {
        super(id, rootElement, dependencies);
        this.componentName = 'Label';
        this.textElementType = 'label';
    }
    draw() {
        super.draw();
        this.renderTooltip();
    }
    renderTooltip() {
        if (this.textElement) {
            if (this.tooltip) {
                this.registerTooltip(this.textElement, {
                    tooltip: this.tooltip,
                    templateId: '',
                    delay: 0
                });
            }
            else {
                this.registerTooltip(this.textElement, {
                    templateId: 'overflow-ellipsis',
                    delay: 600
                    // ,relativeToMouse: true
                });
            }
        }
    }
}
Label.VERSION = '$Revision: 112048 $';
